
import OcRadio from '@marketplace/components/forms/inputs/radiobox.vue'
import { CARTS_UPDATE_RETAILER_VOUCHER_MUTATION } from '@marketplace/graphql/cart.js'
import { trackClick } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalVoucherPicker',

    components: {
        OcRadio,
    },

    props: {
        accountVouchers: {
            type: Array,
            default: () => [],
        },
        displayedVoucher: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            selectedVoucher: 'unveils',
        }
    },

    computed: {
        firstAccountVoucher() {
            return this.accountVouchers[0]
        },
        firstAccountVoucherDisplayedAmount() {
            return this.firstAccountVoucher.isPercentage
                ? `${parseInt(this.firstAccountVoucher.amount)}%`
                : this.$n(this.firstAccountVoucher.amount, 'currency')
        },
    },

    mounted() {
        if (!this.displayedVoucher?.label?.includes('unveils-')) {
            EventBus.$emit('modal-close')
        } else {
            trackClick(
                'Unveils Popup Voucher Switcher Seen',
                { category: 'Cart' },
                ''
            )
        }
    },

    methods: {
        changeSelected(payload) {
            this.selectedVoucher = payload.value
        },
        changeVoucher() {
            if (this.selectedVoucher === 'unveils') {
                this.closeModal()
                return
            }

            this.$apollo
                .mutate({
                    mutation: CARTS_UPDATE_RETAILER_VOUCHER_MUTATION,
                    variables: { voucher: this.firstAccountVoucher.id },
                })
                .then(({ data }) => {
                    if (data?.retailerOrderSetRetailerVoucher?.success) {
                        trackClick(
                            'Retailer Voucher Changed From Unveils Popup',
                            {
                                category: 'Cart',
                                voucherId: this.firstAccountVoucher.id,
                            },
                            ''
                        )
                        this.closeModal()
                    }
                })
        },
        closeModal() {
            EventBus.$emit('modal-close')
            EventBus.$emit('triggerRefreshCart')
        },
    },
}
